import { ALU_2K_GLAZY, SLIDY_30, SLIDY_36 } from './glazingWallTypes';

export const SE0004 = 'SE0004';
export const SE0005 = 'SE0005';
export const SE0026 = 'SE0026';
export const SE0135 = 'SE0135';
export const SE0184 = 'SE0184';
export const SE0204 = 'SE0204';
export const SE0229 = 'SE0229';
export const SE0277 = 'SE0277';
export const SHOP_PROFILE = 'shopprofile';

export const roofProfileTypesByWallTypes = {
  [ALU_2K_GLAZY]: [SE0204],
  [SLIDY_30]: [SE0004, SE0005],
  [SLIDY_36]: [SE0184],
};

const roofProfileTypes = [
  SE0004,
  SE0005,
  SE0026,
  SE0135,
  SE0184,
  SE0229,
  SE0277,
  SHOP_PROFILE,
];

export default roofProfileTypes;
